import React from 'react';
import PropTypes from 'prop-types';
import ProgressBar from 'react-toolbox/lib/progress_bar';

import styles from './Spinner.scss';

const Spinner = ({ className, fullscreen }) => {
  const progress = (
    <ProgressBar
      className={className}
      type="circular"
      mode="indeterminate"
      multicolor
    />
  );
  return fullscreen ? (
    <div className={styles.fullscreen}>{progress}</div>
  ) : (
    progress
  );
};

Spinner.propTypes = {
  className: PropTypes.string,
  fullscreen: PropTypes.bool,
};

export default Spinner;



// WEBPACK FOOTER //
// ./src/client/src/components/Spinner.js